// @flow

import type { Action } from './store.type';
import { ThemesType } from 'src/models/theme-setup';

export const GET_THEMES_REQUEST = 'GET_THEMES_REQUEST';
type GET_THEMES_REQUEST_TYPE = 'GET_THEMES_REQUEST';

export const GET_THEMES_SUCCESS = 'GET_THEMES_SUCCESS';
type GET_THEMES_SUCCESS_TYPE = 'GET_THEMES_SUCCESS';

export const GET_THEMES_FAILURE = 'GET_THEMES_FAILURE';
type GET_THEMES_FAILURE_TYPE = 'GET_THEMES_FAILURE';

export const GET_ALL_THEMES_REQUEST = 'GET_ALL_THEMES_REQUEST';
type GET_ALL_THEMES_REQUEST_TYPE = 'GET_ALL_THEMES_REQUEST';

export const GET_ALL_THEMES_SUCCESS = 'GET_ALL_THEMES_SUCCESS';
type GET_ALL_THEMES_SUCCESS_TYPE = 'GET_ALL_THEMES_SUCCESS';

export const GET_ALL_THEMES_FAILURE = 'GET_ALL_THEMES_FAILURE';
type GET_ALL_THEMES_FAILURE_TYPE = 'GET_ALL_THEMES_FAILURE';

export const CHECK_THEME_REQUEST = 'CHECK_THEME_REQUEST';
type CHECK_THEME_REQUEST_TYPE = 'CHECK_THEME_REQUEST';

export const CHECK_THEME_SUCCESS = 'CHECK_THEME_SUCCESS';
type CHECK_THEME_SUCCESS_TYPE = 'CHECK_THEME_SUCCESS';

export const CHECK_THEME_FAILURE = 'CHECK_THEME_FAILURE';
type CHECK_THEME_FAILURE_TYPE = 'CHECK_THEME_FAILURE';

export const SETUP_THEME_REQUEST = 'SETUP_THEME_REQUEST';
type SETUP_THEME_REQUEST_TYPE = 'SETUP_THEME_REQUEST';

export const SETUP_THEME_SUCCESS = 'SETUP_THEME_SUCCESS';
type SETUP_THEME_SUCCESS_TYPE = 'SETUP_THEME_SUCCESS';

export const SETUP_THEME_FAILURE = 'SETUP_THEME_FAILURE';
type SETUP_THEME_FAILURE_TYPE = 'SETUP_THEME_FAILURE';

export const SUBMIT_ERROR_REQUEST = 'SUBMIT_ERROR_REQUEST';
type SUBMIT_ERROR_REQUEST_TYPE = 'SUBMIT_ERROR_REQUEST';

export const SUBMIT_ERROR_SUCCESS = 'SUBMIT_ERROR_SUCCESS';
type SUBMIT_ERROR_SUCCESS_TYPE = 'SUBMIT_ERROR_SUCCESS';

export const SUBMIT_ERROR_FAILURE = 'SUBMIT_ERROR_FAILURE';
type SUBMIT_ERROR_FAILURE_TYPE = 'SUBMIT_ERROR_FAILURE';

export const RESET_THEME_SETUP = 'RESET_THEME_SETUP';
type RESET_THEME_SETUP_TYPE = 'RESET_THEME_SETUP';

export const INTEGRATE_GEMPAGES_REQUEST = 'INTEGRATE_GEMPAGES_REQUEST';
type INTEGRATE_GEMPAGES_REQUEST_TYPE = 'INTEGRATE_GEMPAGES_REQUEST';

export const INTEGRATE_GEMPAGES_SUCCESS = 'INTEGRATE_GEMPAGES_SUCCESS';
type INTEGRATE_GEMPAGES_SUCCESS_TYPE = 'INTEGRATE_GEMPAGES_SUCCESS';

export const INTEGRATE_GEMPAGES_FAILURE = 'INTEGRATE_GEMPAGES_FAILURE';
type INTEGRATE_GEMPAGES_FAILURE_TYPE = 'INTEGRATE_GEMPAGES_FAILURE';

type ThemeSetupFailure = {
  error: any
};

type GetThemesRequestAction = Action<GET_THEMES_REQUEST_TYPE, null>;

type GetThemesSuccessAction = Action<GET_THEMES_SUCCESS_TYPE, { data: ThemesType }>;

type GetThemesFailureAction = Action<GET_THEMES_FAILURE_TYPE, ThemeSetupFailure>;

type GetAllThemesRequestAction = Action<GET_ALL_THEMES_REQUEST_TYPE, null>;

type GetAllThemesSuccessAction = Action<GET_ALL_THEMES_SUCCESS_TYPE, { data: ThemesType }>;

type GetAllThemesFailureAction = Action<GET_ALL_THEMES_FAILURE_TYPE, ThemeSetupFailure>;

type CheckThemeRequestAction = Action<CHECK_THEME_REQUEST_TYPE, null>;

type CheckThemeSuccessAction = Action<
  CHECK_THEME_SUCCESS_TYPE,
  { data: { inputThemeName: string, outputThemeName: string } }
>;

type CheckThemeFailureAction = Action<CHECK_THEME_FAILURE_TYPE, ThemeSetupFailure>;

type SetupThemeRequestAction = Action<SETUP_THEME_REQUEST_TYPE, null>;

type SetupThemeSuccessAction = Action<SETUP_THEME_SUCCESS_TYPE, { data: { message: string } }>;

type SetupThemeFailureAction = Action<SETUP_THEME_FAILURE_TYPE, ThemeSetupFailure>;

type SubmitErrorRequestAction = Action<SUBMIT_ERROR_REQUEST_TYPE, null>;

type SubmitErrorSuccessAction = Action<SUBMIT_ERROR_SUCCESS_TYPE, { data: { message: string } }>;

type SubmitErrorFailureAction = Action<SUBMIT_ERROR_FAILURE_TYPE, ThemeSetupFailure>;

type ResetThemeSetup = Action<RESET_THEME_SETUP_TYPE>;

type IntegrateGemPagesRequestAction = Action<INTEGRATE_GEMPAGES_REQUEST_TYPE, null>;

type IntegrateGemPagesSuccessAction = Action<
  INTEGRATE_GEMPAGES_SUCCESS_TYPE,
  { data: { message: string } }
>;

type IntegrateGemPagesFailureAction = Action<INTEGRATE_GEMPAGES_FAILURE_TYPE, ThemeSetupFailure>;

export type ThemeSetupAction =
  | GetThemesRequestAction
  | GetThemesSuccessAction
  | GetThemesFailureAction
  | GetAllThemesRequestAction
  | GetAllThemesSuccessAction
  | GetAllThemesFailureAction
  | CheckThemeRequestAction
  | CheckThemeSuccessAction
  | CheckThemeFailureAction
  | SetupThemeRequestAction
  | SetupThemeSuccessAction
  | SetupThemeFailureAction
  | SubmitErrorRequestAction
  | SubmitErrorSuccessAction
  | SubmitErrorFailureAction
  | IntegrateGemPagesRequestAction
  | IntegrateGemPagesSuccessAction
  | IntegrateGemPagesFailureAction
  | ResetThemeSetup;

export type ThemeSetupState = {
  getThemesLoading: boolean,
  getAllThemesLoading: boolean,
  checkThemeLoading: boolean,
  installThemeLoading: boolean,
  integrateGemPagesLoading: boolean,
  getThemesSuccess: boolean,
  getAllThemesSuccess: boolean,
  checkThemeSuccess: boolean,
  installThemeSuccess: boolean,
  submitErrorSuccess: boolean,
  integrateGemPagesSuccess: boolean,
  error: any,
  setupThemeError: any,
  themes: ThemesType | [],
  allThemes: ThemesType | [],
  isTrialTheme: boolean,
  inputThemeName: string,
  outputThemeName: string,
  isOS20: boolean,
  integrateGemPagesThemes: Object
};
